import { Button, Alert } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../assets/css/login.css";
import { authService } from "../services/auth.service";
import Loading from "../components/Util/Loading";
function Login(props) {
  const [state, setState] = useState({
    username: "",
    password: "",
    otp: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [forgotPass, setForgotPass] = useState(false);
  const [success, setSuccess] = useState(false);

  let messageBox = null;

  if (showMessage) {
    messageBox = (
      <Alert variant={success ? "success" : "danger"} dismissible>
        <button
          aria-hidden={true}
          className="close"
          data-dismiss="alert"
          type="button"
          onClick={() => {
            setShowMessage(false);
          }}
        >
          <i className="nc-icon nc-simple-remove"></i>
        </button>
        <span>{message}</span>
      </Alert>
    );
  }

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const showErrorMessage = (res, message) => {
    setShowMessage(true);
    if (res?.message === "Network Error") {
      setMessage("Сүлжээний холболтоо шалгана уу!");
    } else if (res?.error == "UserNotFound" || res?.error == "ClientNotFound") {
      setMessage("Хэрэглэгч олдсонгүй.");
    } else if (res?.error == "UserDeactivated") {
      setMessage("Хэрэглэгч идэвхгүй төлөвт шилжсэн байна.");
    } else if (res?.error == "InvalidPassword") {
      setMessage("Нууц үгээ шалгаад дахин оруулна уу!");
    } else {
      setMessage(message);
    }
  };
  const getOtpCode = async () => {
    setShowMessage(true);
    try {
      const res = await authService.getOtpCode(state.username);
      setSuccess(true);
      setMessage(
        "Таны бүртгэлтэй имейл хаяг руу илгээсэн 4 оронтой кодыг оруулан нууц үгээ шинэчлэнэ үү"
      );
      setForgotPass(true);
    } catch (err) {
      setSuccess(false);
      showErrorMessage(err, err.error_description);
    }
  };
  const getNewPassword = async () => {
    try {
      const res = await authService.getNewPassword(state.username, state.otp);
      setShowMessage(true);
      setSuccess(true);
      setMessage(
        "Амжилттай: таны бүртгэлтэй имейл хаяг руу шинэ нууц үг илгээлээ."
      );
      setForgotPass(false);
      setState((prev) => ({ ...prev, password: "", otp: "" }));
    } catch (err) {
      setSuccess(false);
      // showErrorMessage(err, err.error_description);
      setMessage(err.error_description);
    }
  };

  return (
    <div className="login-wrapper">
      <div id="formContent">
        <div>
          <img
            src="https://www.upoint.mn/images/black-logo.png"
            id="icon"
            alt="User Icon"
          />
        </div>
        {!forgotPass ? (
          <form
            onSubmit={async (e) => {
              let res;
              try {
                e.preventDefault();
                setLoading(true);
                setSuccess(false);
                res = await authService.login(state.username, state.password);
                setShowMessage(true);
                if (res?.message === "Network Error") {
                  setMessage("Сүлжээний холболтоо шалгана уу!");
                } else if (res?.error == "UserNotFound") {
                  setMessage("Хэрэглэгч олдсонгүй.");
                } else if (res?.error == "UserDeactivated") {
                  setMessage("Хэрэглэгч идэвхгүй төлөвт шилжсэн байна.");
                } else if (res?.error == "InvalidPassword") {
                  setMessage("Нууц үгээ шалгаад дахин оруулна уу!");
                } else {
                  setMessage(
                    "Нэвтрэх нэр, нууц үгээ шалгаад дахин оруулна уу!"
                  );
                }
                setLoading(false);
              } catch (err) {
                console.log(err);
              }
            }}
          >
            <input
              type="text"
              id="username"
              className="login-input"
              name="Хэрэглэгчийн нэр"
              placeholder="Хэрэглэгчийн нэр"
              required
              disabled={loading}
              value={state.username}
              onChange={handleChange}
            />
            <input
              type="password"
              id="password"
              className="login-input"
              name="Нууц үг"
              placeholder="Нууц үг"
              required
              value={state.password}
              disabled={loading}
              onChange={handleChange}
            />

            <Button
              className="login-input"
              value="Log In"
              type="submit"
              disabled={loading}
            >
              НЭВТРЭХ
            </Button>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "-30px",
                marginBottom: "10px",
                color: "lightblue",
              }}
            >
              <div
                style={{
                  padding: "4px",
                  marginRight: "20px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (!state.username) {
                    setShowMessage(true);
                    setMessage("Нэвтрэх нэр оруулна уу!");
                    return;
                  }
                  setMessage("");
                  getOtpCode();
                }}
              >
                Нууц үг мартсан
              </div>
            </div>
          </form>
        ) : (
          <form
            onSubmit={async (e) => {
              try {
                e.preventDefault();
                setLoading(true);
                getNewPassword();
                setLoading(false);
              } catch (err) {
                console.log(err);
              }
            }}
          >
            <input
              type="text"
              id="email"
              className="login-input"
              name="Хэрэглэгчийн нэр"
              placeholder="Хэрэглэгчийн нэр"
              required
              disabled={loading}
              value={state.username}
              onChange={handleChange}
            />
            <input
              type="text"
              id="otp"
              className="login-input"
              name="OTP код"
              placeholder="OTP код"
              required
              maxLength={4}
              value={state.otp}
              disabled={loading}
              onChange={handleChange}
            />

            <Button
              className="otp-input"
              value="Log In"
              type="submit"
              disabled={loading}
            >
              Шинэ нууц үг авах
            </Button>
          </form>
        )}
        <div id="formFooter">
          <Loading loading={loading} />
          {messageBox}
        </div>
      </div>
    </div>
  );
}
export default Login;
